import { ImageName } from "@mcleod/images";
import {
    ButtonProps, ButtonVariant, ComponentCreator, ComponentTypes, Label, SaveButton, SaveButtonProps
} from "@mcleod/components";
import { getThemeColor } from "@mcleod/core";

const buttonProps: Partial<ButtonProps> = {
    backgroundColor: "transparent",
    variant: ButtonVariant.round,
    imageWidth: 26,
    imageHeight: 26,
    caption: null,
    width: null,
    height: null,
    padding: 0,
    margin: 0,
    marginRight: 4
}

export class AppSaveButton extends SaveButton {
    private _enabledButtonColor: string;
    private _doAfterEnabledPropChange: () => void;
    private readonly _asWeb: boolean;

    protected constructor(props?: Partial<SaveButtonProps>) {
        super(props);
        // TODO If a specialized caption is being provided,
        //  show the button per //web ui implementation for now.
        //  we will open up more save buttons to be mobile ui as
        //  we are prepared to handle those use cases.
        this._asWeb = props.caption != null;

        if (this._designer == null) {
            if (this._asWeb === false) {
                this.setProps({ backgroundColor: "transparent", minWidth: null, width: null });
                if (props.imageName) {
                    this.primaryButton.setProps({ ...buttonProps, imageName: props.imageName });
                } else {
                    this.primaryButton.setProps({ ...buttonProps, imageName: ImageName.send, imageRotation: 15 });
                }
                this.secondaryButton.setProps({ ...buttonProps });
                this.showSeparator = false;
                this.addMountListener(() => {
                    this.primaryButton.setProps({ caption: null, width: "unset"})
                });
            }
        }
    }

    override updatePrimaryButton(sourceLabel: Label) {
        super.updatePrimaryButton(sourceLabel);
        if (this._asWeb === false)
            this.primaryButton.setProps({ ...buttonProps });
    }

    // !!! The day we want to figure out dropdown items in the mobile app,
    // removing the get/set for them will be the start of that.
    override get dropdownItems(): ComponentCreator[] {
        return super.dropdownItems;
    }

    override set dropdownItems(value: ComponentCreator[]) {
        if (this._asWeb)
            super.dropdownItems = value;
        else
            super.dropdownItems = null;
    }

    protected override applyEnabledTheme() {
        if (this._asWeb) {
            super.applyEnabledTheme();
        } else {
            this._element.removeAttribute("disabled");
            this.primaryButton._element.removeAttribute("disabled");
            this.secondaryButton._element.removeAttribute("disabled");

            this.primaryButton.imageColor = this.enabledButtonColor;
            this.secondaryButton.imageColor = this.enabledButtonColor;
            this.cursor = this.cursor;

            this._doAfterEnabledPropChange?.();
        }
    }

    protected override applyDisabledTheme() {
        if (this._asWeb) {
            super.applyDisabledTheme();
        } else {
            if (this.__designer == null) {
                this._element.setAttribute("disabled", "true");
                this.primaryButton._element.setAttribute("disabled", "true");
                this.secondaryButton._element.setAttribute("disabled", "true");
            }
            // Must change twice for it to take effect...?
            this.primaryButton.imageColor = null;
            this.secondaryButton.imageColor = null;
            this.primaryButton.imageColor = getThemeColor("subtle.light");
            this.secondaryButton.imageColor = getThemeColor("subtle.light");
            this._element.style.cursor = "";

            this._doAfterEnabledPropChange?.();
        }
    }

    get enabledButtonColor(): string {
        return this._enabledButtonColor ?? "primary.reverse";
    }

    set enabledButtonColor(value: string) {
        this._enabledButtonColor = value;
    }

    set doAfterEnabledPropChange(value: () => void) {
        this._doAfterEnabledPropChange = value;
    }
}

ComponentTypes.registerAppComponentType("savebutton", {
    constructor: AppSaveButton.prototype.constructor,
    isCompound: false
});
